import React, { useEffect, useState } from 'react'
import type { PaginationProps } from 'antd';
import { Pagination } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPublicCollections, setPage, setPerPage } from '../../Slices/PublicCollectionsDataSlice';
import styles from './PaginationBar.module.css'
import { useSearchParams } from 'react-router-dom';

// const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
//   if (type === 'prev') {
//     return <a>Previous</a>;
//   }
//   if (type === 'next') {
//     return <a>Next</a>;
//   }
//   return originalElement;
// };

type Props = {
  alignTotalItemsLeft: any,
  show: any,
}


const PaginationBar = (props: Props) => {
  const {alignTotalItemsLeft, show} = props;
  const dispatch = useDispatch();
  const paginationdata = useSelector((state: any) => state.publicCollectionsData.pagination);
  const totalCollections = !paginationdata ? 0 : paginationdata.total_posts;
  const [searchParams, setSearchParams]:any = useSearchParams();


  const GetCurrentPage = () => {
    const pageParams = new URLSearchParams(window.location.search);
    const page = pageParams.get("page");
    return page && !isNaN(parseInt(page)) ? page : 1;
  };
  const GetPageSize = () => {
    const pageSizeParams = new URLSearchParams(window.location.search);
    const pageSize = pageSizeParams.get("per_page");
    return pageSize && !isNaN(parseInt(pageSize)) ? pageSize : 10;
  };
  


  const page:any = GetCurrentPage();
  const pageSize:any = GetPageSize();

  const handlePageChange = (page: any, pageSize: any) => {
    searchParams.set("page", page);
    searchParams.set("per_page", pageSize);
    setSearchParams(searchParams)
    dispatch(fetchPublicCollections({page: searchParams.get('page'), search : searchParams.get('search'), sortBy : searchParams.get('sortby'), perPage : searchParams.get('per_page')}));
    
  };

  return (
  <>
  {/* <Pagination className={styles.pagination} responsive showSizeChanger={false} total={totalCollections} onChange={handlePageChange} itemRender={itemRender} /> */}

  <Pagination
    style={show ? {display: "flex", justifyContent: "flex-end"} : {display: "none"}}
    total={totalCollections}
    showSizeChanger
    showQuickJumper
    rootClassName={alignTotalItemsLeft ? styles.publicPagination : undefined}
    // current={paginationdata ? paginationdata.current_page : 1} // current page is showing different data everytime
    className={styles.pagination}
    responsive
    current={page}
    pageSize={pageSize}
    // hideOnSinglePage
    onChange={handlePageChange} 
    // itemRender={itemRender}
    size='small'
    showTotal={(total) => `Total ${totalCollections} items`}
  />
  </>
  )
}

export default PaginationBar